<template>
  <v-layout row wrap>
    <v-flex v-for="(config, idx) in originalConfigurations" :key="idx" xs12 sm12 md12>
      <v-card-title>
        <h2> {{ config.Name}} </h2>
      </v-card-title>
      <v-card elevation=1>
        <v-card-text>
          {{ config.Description }}
          <v-layout row wrap align-center justify-end>
            <v-btn @click="goToEdit(config.Name)" color="primary">Edit
              <v-icon class="ml-2" dark>edit</v-icon>
            </v-btn>
            <v-btn @click="goToView(config.Name)" color="white">View
              <v-icon class="ml-2" dark>visibility</v-icon>
            </v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import genericMixin from '../mixins/genericMixin'
  import routingMixin from '../mixins/routingMixin'

  const eddConfiguration = createNamespacedHelpers('plugin/eddConfiguration')
  export default {
    mixins: [genericMixin, routingMixin],
    computed: {
      ...eddConfiguration.mapGetters(['originalConfigurations', 'configurations']),
    },
    methods: {
      ...eddConfiguration.mapActions(['fetchConfigurationSettings']),
      goToEdit(configurationSettingName) {
        this._mixin_routing_navigateTo('configurationSettingDetail', {
          ConfigurationSettingName: configurationSettingName,
          initialEditMode: true,
        })
      },
      goToView(configurationSettingName) {
        this._mixin_routing_navigateTo('configurationSettingDetail', {
          ConfigurationSettingName: configurationSettingName,
          initialEditMode: false,
        })
      },
      handleErrors() {},
    },
    async created() {
      try {
        await this.fetchConfigurationSettings()
      } catch (error) {
        this._mixin_generic_handleError(error)
      }
    },
  }

</script>
